import React from 'react';
import { DropzoneDialog } from 'mui-file-dropzone';
import { ModalsKeys } from '../../../../global';
import { useModal } from '../../../../hooks/useModal';

export const FileUploadModal = () => {
  const { isOpen, data, handleClose } = useModal(ModalsKeys.FileUploadDialog);

  const handleSave = (files: File[]) => {
    if (data?.onUpload) {
      data.onUpload(files);
    }
    handleClose();
  };

  return (
    <DropzoneDialog
      open={isOpen}
      onSave={handleSave}
      onClose={handleClose}
      dialogTitle={data?.title ?? 'Upload Files'}
      acceptedFiles={data?.acceptedFiles}
      filesLimit={data?.filesLimit ?? 5}
      maxFileSize={data?.maxFileSize ?? 10000000}
      cancelButtonText="Cancel"
      submitButtonText="Upload"
      fileObjects={[]}
    />
  );
};
